module.exports = __webpack_public_path__ + "img/gira.79e3fe70.png";